export function viewableUrlFile(url) {
  if (!url) return;
  if (typeof url !== "string") return;
  return url?.split("/")?.splice(3)?.join("/");
  // return url?.split("/")?.splice(2)?.join("/");
}
